import React from 'react';
import './_footer.scss';

function Footer() {
  return (
    <footer className="footer">
      <div className="wrapper footer__wrapper">
        <div className="footer__copyright">
          <span className="copyright">©</span>
          <span className="year">2022</span>
          <div className="footer__info">
            <a
              className="github-username"
              target="_blank"
              rel="noreferrer"
              href="https://github.com/OutLaw0"
            >
              github
            </a>
          </div>
        </div>

        <a href="https://rs.school/react/" className="rss" target="_blank" rel="noreferrer">
          Rolling Scopes School
        </a>
      </div>
    </footer>
  );
}

export default Footer;
